import { defineMessages } from 'react-intl';

export const controlsList = [{
  name: 'bodyFontSize',
  labelId: 'BODY_FONT_SIZE',
  type: 'slider',
  default: 14,
  options: {
    min: 8,
    max: 40,
    step: 1,
  },
}, {
  name: 'cellPadding',
  labelId: 'CELL_PADDING',
  type: 'slider',
  default: 4,
  options: {
    min: 1,
    max: 20,
    step: 1,
  },
}];

const messages = defineMessages({
  OVERFLOW: {
    id: 'OVERFLOW',
    defaultMessage: 'Overflow',
  },
  PAGINATION: {
    id: 'PAGINATION',
    defaultMessage: 'Pagination',
  },
  SCROLL: {
    id: 'SCROLL',
    defaultMessage: 'Scroll',
  },
  NONE: {
    id: 'NONE',
    defaultMessage: 'None',
  },
  GRID: {
    id: 'GRID',
    defaultMessage: 'Grid',
  },
  FONT_SIZE: {
    id: 'FONT_SIZE',
    defaultMessage: 'Font Size',
  },
  HEADER_FONT_SIZE: {
    id: 'HEADER_FONT_SIZE',
    defaultMessage: 'Header Font Size',
  },
  BODY_FONT_SIZE: {
    id: 'BODY_FONT_SIZE',
    defaultMessage: 'Body Font Size',
  },
  CELL_PADDING: {
    id: 'CELL_PADDING',
    defaultMessage: 'Cell Padding',
  },
});

function GridTableStyleControls({ renderControlGroup }) {
  const controlsGroups = [{
    labelId: 'GRID',
    controls: controlsList,
  }];

  return controlsGroups.map(
    (controlsGroup, cgIndex) => renderControlGroup(controlsGroup, messages, cgIndex),
  );
}

export default GridTableStyleControls;
